export default "__VITE_ASSET__55a3a624__"